import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.meeting.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-meeting-list',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.meeting.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabMeetingListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public meetings: any[] = [];
    public workspaces: any[] = [];
    public members: any[] = [];
    public memberMap: any = {};
    public me: string = '';
    public loaded: boolean = false;

    public filterWs: string = '';
    public filterStatus: string = '';
    public showUpcoming: boolean = false;

    public showCreate: boolean = false;
    public form: any = this.emptyForm();
    public participantInput: string = '';

    public emptyForm() {
        const now = new Date();
        const next = new Date(now.getTime() + 60 * 60 * 1000);
        const pad = (n: number) => String(n).padStart(2, '0');
        const toLocal = (d: Date) =>
            `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
        return {
            title: '', description: '',
            scheduled_at: toLocal(next),
            duration: 60,
            workspace_id: '',
            room_url: '',
            agenda: '',
            participants: [] as string[],
        };
    }

    public async ngOnInit() {
        await this.service.init();
        await this.loadMembers();
        await this.loadWorkspaces();
        await this.load();
    }

    public async load() {
        const params: any = {};
        if (this.filterWs) params.workspace_id = this.filterWs;
        if (this.filterStatus) params.status = this.filterStatus;
        if (this.showUpcoming) params.upcoming = '1';
        const r = await wiz.call("list", params);
        if (r.code === 200) {
            this.meetings = r.data.rows || [];
            this.me = r.data.me;
        }
        this.loaded = true;
        await this.service.render();
    }

    public async loadWorkspaces() {
        const r = await wiz.call("workspaces", {});
        if (r.code === 200) this.workspaces = r.data.rows || [];
    }

    public async loadMembers() {
        const r = await wiz.call("members", {});
        if (r.code === 200) {
            this.members = r.data.rows || [];
            this.memberMap = {};
            for (const m of this.members) this.memberMap[m.id] = m;
        }
    }

    public memberName(uid: string) {
        return this.memberMap[uid]?.name || this.memberMap[uid]?.email || uid;
    }

    public openCreate() {
        this.form = this.emptyForm();
        this.showCreate = true;
    }

    public toggleParticipant(uid: string) {
        const i = this.form.participants.indexOf(uid);
        if (i >= 0) this.form.participants.splice(i, 1);
        else this.form.participants.push(uid);
    }

    public isSelected(uid: string) {
        return this.form.participants.includes(uid);
    }

    public async submitCreate() {
        if (!this.form.title?.trim()) {
            this.service.alert.error('제목을 입력해주세요.');
            return;
        }
        const payload: any = {
            title: this.form.title.trim(),
            description: this.form.description || '',
            scheduled_at: this.form.scheduled_at.replace('T', ' ') + ':00',
            duration: this.form.duration,
            workspace_id: this.form.workspace_id || '',
            room_url: this.form.room_url || '',
            agenda: this.form.agenda || '',
            participants: this.form.participants.join(','),
        };
        const r = await wiz.call("create", payload);
        if (r.code === 200) {
            this.showCreate = false;
            await this.load();
        } else {
            this.service.alert.error(r.data?.message || '실패');
        }
    }

    public open(m: any) {
        this.service.href(`/admin/collab/meeting/${m.id}`);
    }

    public async remove(m: any, ev: Event) {
        ev.stopPropagation();
        if (!confirm(`회의 '${m.title}'를 삭제하시겠습니까?`)) return;
        const r = await wiz.call("remove", { id: m.id });
        if (r.code === 200) await this.load();
        else this.service.alert.error(r.data?.message || '삭제 실패');
    }

    public statusBadge(s: string) {
        const map: any = {
            scheduled: { label: '예정', cls: 'bg-blue-50 text-blue-600' },
            live: { label: '진행중', cls: 'bg-emerald-50 text-emerald-600 animate-pulse' },
            ended: { label: '종료', cls: 'bg-zinc-100 text-zinc-500' },
            cancelled: { label: '취소', cls: 'bg-rose-50 text-rose-600' },
        };
        return map[s] || { label: s, cls: 'bg-zinc-100 text-zinc-500' };
    }
}

export default PortalLpsysadminCollabMeetingListComponent;